import React, { useEffect, useState } from 'react';   
import './contact.css';

type Domain = "com" | "ly" | "no";

export default function Contact() {  
    const [domain, setDomain] = useState<Domain>("com"); // SSR/default fallback

    useEffect(() => {
        document.title = "MOHAMED BAKOUSH | CONTACT";
        
        const hostname = window.location.hostname;
        if (hostname.endsWith(".ly")) {
            setDomain("ly");
        } else if (hostname.endsWith(".no")) {
            setDomain("no");
        } else {
            setDomain("com");
        }
    }); 
 

    const email = `mohamed@bakoush.${domain}`;
    const displayDomain = `@BAKOUSH.${domain.toUpperCase()}`;

    return (
        <article className="contact-article">
            <section className="contact-wrapper"> 
                <section>

                    <section className="contact-wrapper-content">
                        <p className="contact-title">
                            GET IN TOUCH
                        </p>
                        <p className="contact-description-email">
                            <a href={`mailto:${email}`}>
                                <span>
                                    MOHAMED
                                </span>
                                <span>
                                    {displayDomain}
                                </span>
                            </a>
                        </p>
                    </section>
    


                    <section className="contact-wrapper-content"> 
                        <p className="contact-title">  
                            YOU CAN FOLLOW MY WORK ON
                        </p> 
                        <p className="contact-description"> 
                            <a href="https://github.com/MohamedBakoush" rel="noreferrer" target="_blank">  
                                GITHUB
                            </a>     
                        </p> 
                        <p className="contact-description"> 
                            <a href="https://www.linkedin.com/in/mohamed-bakoush/" rel="noreferrer" target="_blank">  
                                LINKEDIN
                            </a>    
                        </p>
                    </section>  
                    
                </section>  
            </section>
        </article>
    )
}